function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { Filter } from '@finect/tabular-icons/filter';
import { OverflowMenu } from '../../OverflowMenu';
import { FilterTitle, Handler } from '../partials';
import { SearchInput } from '../../Forms/SearchInput';
import { CheckboxItems, Controls } from './partials';
import { convertValuesToResponse, checkedValue, getInitialValue } from './utils';
var AVAILABLE_ICONS = {
  filter: Filter
};
export var CheckboxFilter = function (_React$Component) {
  _inherits(CheckboxFilter, _React$Component);
  var _super = _createSuper(CheckboxFilter);
  function CheckboxFilter() {
    var _this;
    _classCallCheck(this, CheckboxFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "child", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: _this.props.open || false,
      value: getInitialValue(_this.props.initialValue || []),
      prevValue: getInitialValue(_this.props.initialValue || []),
      search: ''
    });
    _defineProperty(_assertThisInitialized(_this), "handleCheckboxChange", function (event) {
      var _event$target = event.target,
        checked = _event$target.checked,
        name = _event$target.name;
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        multiple = _this$props.multiple;
      var newValue = multiple ? _objectSpread(_objectSpread({}, _this.state.value), _defineProperty({}, name, checked)) : _defineProperty({}, name, checked);
      _this.setState({
        value: checkedValue(newValue)
      }, function () {
        return onChange && onChange(convertValuesToResponse(_this.state.value));
      });
      return checked;
    });
    _defineProperty(_assertThisInitialized(_this), "handleReturn", function () {
      var onReturn = _this.props.onReturn;
      _this.setState({
        open: false,
        prevValue: _this.state.value
      });
      _this.child.close();
      typeof onReturn !== 'undefined' && onReturn(convertValuesToResponse(_this.state.value));
    });
    _defineProperty(_assertThisInitialized(_this), "handleRestore", function () {
      var onReset = _this.props.onReset;
      typeof onReset !== 'undefined' && onReset();
      _this.setState({
        value: {}
      }, function () {
        _this.handleReturn();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.setState({
        prevValue: _this.state.value,
        open: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        value: _this.state.prevValue,
        open: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (event) {
      _this.setState({
        search: event.target.value
      });
    });
    return _this;
  }
  _createClass(CheckboxFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps.initialValue) !== JSON.stringify(this.props.initialValue)) {
        this.setState({
          value: getInitialValue(this.props.initialValue || []),
          prevValue: getInitialValue(this.props.initialValue || [])
        });
      }
      if (prevProps.activeFilter && !this.props.activeFilter) {
        this.setState({
          value: {},
          prevValue: {},
          open: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        open = _this$state.open,
        value = _this$state.value,
        prevValue = _this$state.prevValue;
      var _this$props2 = this.props,
        placeholder = _this$props2.placeholder,
        _this$props2$options = _this$props2.options,
        options = _this$props2$options === void 0 ? [] : _this$props2$options,
        title = _this$props2.title,
        search = _this$props2.search,
        multiple = _this$props2.multiple,
        right = _this$props2.right,
        _this$props2$leadingI = _this$props2.leadingIcon,
        leadingIcon = _this$props2$leadingI === void 0 ? null : _this$props2$leadingI;
      var response = convertValuesToResponse(this.state.value);
      var isActive = this.state.value && Object.keys(this.state.value).length > 0;
      var getActiveText = function getActiveText() {
        var prevValueLength = Object.keys(prevValue).length;
        if (!prevValueLength) return placeholder;
        if (prevValueLength === 1) {
          var prev = convertValuesToResponse(_this2.state.prevValue);
          var _prev = _slicedToArray(prev, 1),
            first = _prev[0];
          var option = options.find(function (_ref2) {
            var id = _ref2.id;
            return id.toString() === first.id;
          }) || {
            label: placeholder
          };
          return option.label;
        }
        if (prevValueLength > 1) return 'Múltiple';
      };
      return React.createElement(Fragment, null, options.length ? React.createElement(OverflowMenu, {
        right: right,
        active: isActive,
        placeholder: getActiveText(),
        open: open,
        ref: function ref(_ref3) {
          return _this2.child = _ref3;
        },
        onOpen: this.handleOpen,
        onClose: this.handleClose,
        leadingIcon: leadingIcon ? AVAILABLE_ICONS[leadingIcon] : null
      }, title ? React.createElement(FilterTitle, null, title) : null, search ? React.createElement(SearchInput, {
        search: this.state.search,
        onChange: this.handleSearchChange
      }) : null, React.createElement(CheckboxItems, {
        options: options,
        multiple: multiple,
        value: value,
        search: this.state.search,
        onCheckboxChange: this.handleCheckboxChange
      }), React.createElement(Controls, {
        restoreDisabled: response.length === 0,
        actionDisabled: false || Boolean(!value),
        onRestore: this.handleRestore,
        onReturn: this.handleReturn
      })) : React.createElement(Handler, {
        width: "auto",
        variant: "small",
        disabled: true
      }, placeholder));
    }
  }]);
  return CheckboxFilter;
}(React.Component);
_defineProperty(CheckboxFilter, "defaultProps", {
  multiple: false,
  initialValue: [],
  activeFilter: null,
  search: false,
  right: false
});